module.exports = __webpack_public_path__ + "img/sport-77-@1x.6f36a123.png";